var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{key:_vm.$route.path}),_c('div',{staticClass:"chat-container"},[_c('chat-form')],1),_c('footer-comp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }